//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum JobPriority {
    Low = 1,
    Medium = 2,
    High = 3,
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum JobStatus {
    ToDo = 1,
    InProgress = 2,
    Done = 3,
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum JobType {
    DataGathering = 1,
    VideoInspection = 2,
    VideoQA = 3,
    Other = 4,
}
